import { getRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const getLegacyOrders = ({ accountUid, page, size }) =>
  getRequest(
    replaceInUrl(apiEndpoints.legacyOrders.get, { accountUid, page, size }),
  );
